import React from 'react';
import prettier from 'prettier/standalone';
import parserBabel from 'prettier/parser-babel';
import styled from 'styled-components';
import { logger } from '@utils/usefulFuncs';

const Wrapper = styled.pre`
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  padding: 0 0 9px 0;
  word-break: break-word;
  white-space: pre-wrap;
`;

export const PrettyJSON = ({ value }) => {
  const [prettyJson, setPrettyJson] = React.useState('');

  React.useEffect(() => {
    const run = async () => {
      // console.log('value', value);
      let sanitizedValue = value;

      if (typeof value !== 'string') {
        sanitizedValue = JSON.stringify(value);
      }

      sanitizedValue = sanitizedValue.replace(/^```json\s*\n?/, '').replace(/\n?```\s*$/, '');

      try {
        let pretty = await prettier.format(sanitizedValue, {
          parser: 'json',
          plugins: [parserBabel],
          tabWidth: 4,
        });

        // Unescape dollar signs that were incorrectly escaped
        // Replace \$ with $ to fix invalid JSON
        pretty = pretty.replace(/\\(\$)/g, '$1');
        pretty = pretty.replace(/null/g, '');

        setPrettyJson(pretty);
      } catch (e) {
        logger('error formatting JSON', e);
        setPrettyJson(value || 'Invalid JSON');
      }
    };
    run();
  }, [value]);

  return <Wrapper>{prettyJson}</Wrapper>;
};
